import get from 'lodash/get';
import queryString from 'query-string';

import { USER_INFO_SUCCESS } from 'redux/User';

export const FEATURE_FLAGS = {
  UseConfigCatFeatureFlags: 'fe_use_config_cat_feature_flags',
  LogReduxActions: 'fe_log_redux_actions',
  CustomDesignPackage: 'fe_custom_design_package',
  ExpeditedDelivery: 'fe_expedited_delivery',
  DownForMaintenance: 'fe_down_for_maintenance',
  ScreenInfoDebug: 'fe_screen_info_debug',
  TatariProvider: 'fe_tatari_provider',
  VariantProducts: 'fe_variant_products',
  StudioMerchConversionBanner: 'fe_studio_merch_conversion_banner',
  ShowPromotionsOnCart: 'fe_show_promotions_on_cart',
  MultiRoomLuxe: 'fe_multi_room_luxe',
  ShowMicroShops: 'fe_show_micro_shops',
  ShowZendeskInMerchCart: 'fe_show_zendesk_in_merch_cart',
  ShowZendeskInYourRecommendation: 'fe_show_zendesk_in_your_recommendation',
  SpecialMessaging: 'fe_pdp_special_messaging',

  // created: 2020-01-03, expiration: 2020-04-02, from: bhkim7000, impact: MessengerStudio, reason: New UI for Swapping
  UpdatedMessengerSwapUI: 'fe_updated_messenger_swap_ui',

  // created: 2020-04-08, from: bhkim7000, impact: Shop,
  // reason: Display browsable product categories in shop
  ProductCategories: 'fe_product_categories',

  // created: 2020-07-10, from: glredig, impact: Studio,
  // reason: Updating UI and filter functionality for alternatives
  AlternativesFilters: 'fe_alternatives_filters',

  // created: 2020-08-06, from: bsholmes, impact: Studio, Project
  // reason: Show Messenger in studio and project pages
  Messenger: 'fe_messenger',

  // created: 2020-08-11, from: jbimagine, impact: PPO style match
  // reason: Show Hotspots in Style Match
  StyleMatchHotspots: 'fe_style_match_hotspots',

  // created: 2020-09-15, from glredig, impact: Shop
  // reason: Show (swappable) favorites in the alternatives pane
  AlternativesFavorites: 'fe_alternatives_favorites',

  // created: 2020-10-05, from: glredig, impact: Studio
  // reason: Show 3d and 2d products in list
  Include2DProducts: 'fe_include_2d_products',

  // created: 2020-11-09, from floustao, impact: regular PPO
  // reason: Update some redirection inside PPO flow.
  // ex: click on Continue CTA from About-you page should redirect
  // to Summary page instead of PPO dashboard to reduce clicks.

  // NOTE: To remove once regular /PPO/ folder has been removed completely,
  // replaced by permanent /PPOMonarch/
  RedirectPPOFlow: 'fe_redirect_ppo_flow',

  // added: 2020-11-17, by Nathan, impact: PPO/Studio
  // reason: Redirect to landing page for routes that do
  // not reference a spaceId ex. /spaces
  RedirectToLandingPage: 'fe_monarch_post_login_redirect',

  // added: 2021-01-11, by floustao, impact: Monarch PPO
  // reason: Skips step 3 after clicking 'Continue' or 'Back' from steps 2 & 4 in case
  // step 3 is locked (it needs to be locked after user captured photos through the ios app).
  LockRoomDetailsAfterIOSCapture: 'fe_lock_room_details_after_ios_capture',

  // added: 2021-01-28, by floustao, impact: Global - navigation bars
  // reason: Add a help menu in navigation bars.
  ShowHelpMenu: 'fe_show_help_menu',

  // added: 2021-02-02, by floustao, impact: Global - Admin banner
  // reason: Show extra top Banner when an admin user is viewing a customer
  // profile page (Studio, project & design pages).
  ShowAdminBanner: 'fe_enable_admin_banner',

  // added: 2021-03-03, by nathan, impact: 'Get in touch' button in help menu
  // reason: enable/disable header zendesk functionality
  ZendeskChatbot: 'fe_zendesk_chatbot',

  // added: 2021-11-17, by brian
  // reason: enables zendesk chat on merch checkout
  ZendeskChatbotMerchCheckout: 'fe_zendesk_chatbot_merch_checkout',

  // added: 2021-03-01, by blenoski, impact: account settings page
  // reason: Allow designers/admins to edit user account profile plus Monarchize the page.
  MonarchizeAccountAdmin: 'fe_monarchize_account_admin',

  // added: 2021-03-29, by floustao, impact: Merch checkout
  // reason: Add an address validation step to reduce the need of address manual edits.
  StandardizeAddress: 'fe_standardize_address',

  // added: 2021-05-24, by amydecat, impact: Checkout page
  // reason: Add a dynamic tiered promotional banner to the top of the Cart Summary.
  TieredPromoEnabled: 'fe_tiered_promo',

  // added: 2021-04-16, by RIP floustao, impact: package checkout
  // reason: To hide the expedited delivery addon for some specific design packages
  UseExpeditedDeliverySupport: 'fe_use_expedited_delivery_support',

  // added: 2021-07-22, by blenoski, impact: package checkout
  // reason: When enabled, package checkout will use the 'supports_multiroom' property from BE API
  // response to determine whether or not to show the multiroom selection UI on package checkout
  PackagesUseSupportMultiroom: 'fe_packages_use_support_multiroom',

  // added: 2021-10-22, by panchograblev, impact: Design Feed Room page
  // reason: When enabled, products will open in standalone page instead of Product Details Modal
  UsePDPStandalone: 'fe_pdp_standalone',

  // added: 2021-09-02, by panchograblev, impact: package checkout
  // reason: When enabled, package checkout will use shorter flow on Monarch
  PackageCheckoutShortMonarch: 'fe_package_checkout_short_monarch',

  // added: 2021-12-10, by vasilspasov, impact: style quiz
  // reason: When enabled, products selection in style quiz
  // is shortened to one step instead of three
  ShortStyleQuiz: 'fe_short_style_quiz',

  // added: 2022-03-13, by glredig, impact: cart + PDP
  // reason: When enabled, cart items and PDP have free shipping messaging
  ShowFreeShippingMessage: 'fe_show_free_shipping',

  // added: 2022-05-06, by glredig, impact: cart
  // reason: When enabled, user is presented with monarchized cart
  CartReskin: 'fe_cart_reskin'
};

/**
 * Reducer for tracking feature flag state.
 * Toggling feature flags is currently hidden
 * behind an admin only modal that can be enabled
 * from the navbar. The expected shape of actions
 * emitted from the admin only modal is:
 *
 * dispatch({
 *  type: 'FEATURE',
 *  payload: {
 *    id: '<your unique feature name here>',
 *    enabled: <true or false (required)>
 *    data: {<extra data here (optional)>}
 *  }
 * }))
 *
 * Any dispatched action with type='FEATURE' is saved here
 * to reducer state. The payload must be an object and must
 * contain both 'id' and 'enabled' fields. The data field is
 * optional.
 *
 * Components that depend on features can connect
 * to the redux store and get feature flag data they
 * care about using the getFeatureFlagById selector
 * which will return { enabled, data } object.
 * If there is no feature in state when getFeatureFlagById
 * is called, then the default action is to return
 * { enabled: false, data: null }
 */

/**
* Pre-define some feature flags.
*/
let initialState = {
  [FEATURE_FLAGS.UseConfigCatFeatureFlags]: { enabled: true, data: null },
  [FEATURE_FLAGS.LogReduxActions]: { enabled: false, data: null },
  [FEATURE_FLAGS.CustomDesignPackage]: { enabled: false, data: null },
  [FEATURE_FLAGS.ExpeditedDelivery]: { enabled: true, data: null },
  [FEATURE_FLAGS.DownForMaintenance]: { enabled: false, data: null },
  [FEATURE_FLAGS.ScreenInfoDebug]: { enabled: false, data: null },
  [FEATURE_FLAGS.TatariProvider]: { enabled: true, data: null },
  [FEATURE_FLAGS.VariantProducts]: { enabled: true, data: null },
  [FEATURE_FLAGS.StudioMerchConversionBanner]: { enabled: true, data: null },
  [FEATURE_FLAGS.ShowPromotionsOnCart]: { enabled: true, data: null },
  [FEATURE_FLAGS.MultiRoomLuxe]: { enabled: true, data: null },
  [FEATURE_FLAGS.ShowMicroShops]: { enabled: true, data: null },
  [FEATURE_FLAGS.ShowZendeskInMerchCart]: { enabled: true, data: null },
  [FEATURE_FLAGS.ShowZendeskInYourRecommendation]: { enabled: false, data: null },
  [FEATURE_FLAGS.UpdatedMessengerSwapUI]: { enabled: false, data: null },
  [FEATURE_FLAGS.AlternativesFilters]: { enabled: false, data: null },
  [FEATURE_FLAGS.Messenger]: { enabled: false, data: null },
  [FEATURE_FLAGS.StyleMatchHotspots]: { enabled: false, data: null },
  [FEATURE_FLAGS.AlternativesFavorites]: { enabled: false, data: null },
  [FEATURE_FLAGS.Include2DProducts]: { enabled: false, data: null },
  [FEATURE_FLAGS.RedirectPPOFlow]: { enabled: false, data: null },
  [FEATURE_FLAGS.RedirectToLandingPage]: { enabled: false, data: null },
  [FEATURE_FLAGS.LockRoomDetailsAfterIOSCapture]: { enabled: false, data: null },
  [FEATURE_FLAGS.ShowHelpMenu]: { enabled: false, data: null },
  [FEATURE_FLAGS.ZendeskChatbot]: { enabled: false, data: null },
  [FEATURE_FLAGS.ZendeskChatbotMerchCheckout]: { enabled: false, data: null },
  [FEATURE_FLAGS.AddReviewStepInPPOCheckout]: { enabled: false, data: null },
  [FEATURE_FLAGS.MonarchizeAccountAdmin]: { enabled: false, data: null },
  [FEATURE_FLAGS.StandardizeAddress]: { enabled: false, data: null },
  [FEATURE_FLAGS.TieredPromoEnabled]: { enabled: false, data: null },
  [FEATURE_FLAGS.UseExpeditedDeliverySupport]: { enabled: false, data: null },
  [FEATURE_FLAGS.PackagesUseSupportMultiroom]: { enabled: false, data: null },
  [FEATURE_FLAGS.UsePDPStandalone]: { enabled: false, data: null },
  [FEATURE_FLAGS.PackageCheckoutShortMonarch]: { enabled: false, data: null },
  [FEATURE_FLAGS.ShortStyleQuiz]: { enabled: false, data: null },
  [FEATURE_FLAGS.ShowFreeShippingMessage]: { enabled: false, data: null },
  [FEATURE_FLAGS.CartReskin]: { enabled: false, data: null }
};

/**
 * Enable features via query params, e.g., &FeatureName=true
 * We only allow certain features to be enabled via query params.
 */
const WHITELISTED_FEATURE_FLAGS = [
  FEATURE_FLAGS.UpdatedMessengerSwapUI,
  FEATURE_FLAGS.UseConfigCatFeatureFlags,
  FEATURE_FLAGS.LogReduxActions,
  FEATURE_FLAGS.CustomDesignPackage,
  FEATURE_FLAGS.ExpeditedDelivery,
  FEATURE_FLAGS.ScreenInfoDebug,
  FEATURE_FLAGS.MultiRoomLuxe,
  FEATURE_FLAGS.ShowMicroShops,
  FEATURE_FLAGS.AlternativesFilters,
  FEATURE_FLAGS.Messenger,
  FEATURE_FLAGS.AlternativesFavorites,
  FEATURE_FLAGS.Include2DProducts,
  FEATURE_FLAGS.RedirectPPOFlow,
  FEATURE_FLAGS.RedirectToLandingPage,
  FEATURE_FLAGS.LockRoomDetailsAfterIOSCapture,
  FEATURE_FLAGS.ShowHelpMenu,
  FEATURE_FLAGS.ZendeskChatbot,
  FEATURE_FLAGS.ZendeskChatbotMerchCheckout,
  FEATURE_FLAGS.AddReviewStepInPPOCheckout,
  FEATURE_FLAGS.MonarchizeAccountAdmin,
  FEATURE_FLAGS.StandardizeAddress,
  FEATURE_FLAGS.TieredPromoEnabled,
  FEATURE_FLAGS.UseExpeditedDeliverySupport,
  FEATURE_FLAGS.PackagesUseSupportMultiroom,
  FEATURE_FLAGS.UsePDPStandalone,
  FEATURE_FLAGS.PackageCheckoutShortMonarch,
  FEATURE_FLAGS.ShortStyleQuiz,
  FEATURE_FLAGS.ShowFreeShippingMessage,
  FEATURE_FLAGS.CartReskin
];

const getCleanedFlags = (flags) => {
  return Object.entries(flags).reduce((accum, [flagName, flagEnabled]) => {
    // Skip feature flags not marked front end
    const frontEndPrefix = 'fe';
    if (!flagName || !flagName.startsWith(frontEndPrefix)) {
      return accum;
    }

    return {
      ...accum,
      [flagName]: { enabled: flagEnabled, data: null }
    };
  }, {});
};

const getWhitelistedFeaturesEnabled = () => {
  // fetch search params
  const parsed = queryString.parse(window.location.search);

  return WHITELISTED_FEATURE_FLAGS.reduce((accum, flagName) => {
    const paramBool = parsed[flagName];
    if (paramBool === undefined) {
      return accum;
    }

    const enabled = paramBool === 'true';

    return {
      ...accum,
      [flagName]: { enabled, data: null }
    };
  }, {});
};

/**
 * Feature flag action types
 */
const SET_FEATURE_ENABLED = 'features/SET_FEATURE_ENABLED';

/**
 * Feature flag actions
 */

export const setFeatureEnabled = ({ id, enabled, data }) => ({
  type: SET_FEATURE_ENABLED,
  payload: {
    id,
    enabled,
    data
  }
});

/**
 * Feature flag reducer.
 */
export const featureFlagReducerKey = 'features';

export const featureFlagReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FEATURE_ENABLED: {
      const { id, enabled, data } = action.payload;
      if (id && enabled !== undefined) {
        // Add feature flag to state (updates if already existing)
        return { ...state, [id]: { enabled: !!enabled, data: data || null } };
      }
      console.log('FEATURE action requires id and data fields in payload', action);
      return state;
    }
    // Update feature flag payload based on config cat values
    // returned in auth data success
    case USER_INFO_SUCCESS: {
      const { flags } = action.payload;

      if (!flags) {
        return state;
      }

      const cleanedFlags = getCleanedFlags(flags);
      const whitelistedFlags = getWhitelistedFeaturesEnabled();

      const updatedState = {
        ...state,
        ...cleanedFlags,
        ...whitelistedFlags
      };

      // TODO: Remove soon; initial state values here will become deprecated quickly.
      // Temporary check so can roll out this feature flag switch behind a feature flag.
      // NOTE: This is not switchable in admin panel.
      const useConfigCatFeatureFlags = get(updatedState, FEATURE_FLAGS.UseConfigCatFeatureFlags, false);

      if (useConfigCatFeatureFlags) {
        return updatedState;
      }

      return {
        ...state,
        ...whitelistedFlags
      };
    }
    default: {
      return state;
    }
  }
};

// Selectors
const defaultDisabled = { enabled: false, data: null };

export const getFeatureFlagById = ({ featureId, state }) => {
  if (featureId === undefined) { console.error('featureID undefined'); }
  return get(state, `[${featureFlagReducerKey}][${featureId}]`, defaultDisabled);
};

export const getFeatureFlagEnabledBool = (flag, state) => {
  return getFeatureFlagById({
    featureId: flag,
    state
  }).enabled;
};

export const getAllFeatureFlags = state => state[featureFlagReducerKey];
